import { FC } from 'react';
import ButtonGroup from 'components/Base/ButtonGroup/ButtonGroup';
import { Flex } from 'antd';
import { TimeOutline } from 'assets/icon/icon';
import { Text } from 'components/Base/Typography';
import { useEditWorkshopTimezoneMutation } from 'redux/apiSlice/workshops.slice';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { TRtkErrorType } from 'data/types/generic.types';
import { useTranslation } from '@packages/utils';
import { EWorkshopStatus, TWorkshopTimezone } from 'data/types/workshops.types';

interface TimezoneSelectorProps {
  workshopId: string;
  timezone?: TWorkshopTimezone | null;
  workshopStatus?: EWorkshopStatus;
}

const TimezoneSelector: FC<TimezoneSelectorProps> = ({
  workshopId,
  timezone,
  workshopStatus,
}) => {
  const { t } = useTranslation();
  const { showToastNotification } = useShowToastNotification();
  const [editWorkshopTimezone, { isLoading }] =
    useEditWorkshopTimezoneMutation();

  const isDisabled =
    workshopStatus === EWorkshopStatus.PUBLISHED ||
    workshopStatus === EWorkshopStatus.CANCELLED ||
    workshopStatus === EWorkshopStatus.CLOSED ||
    isLoading;

  const timezoneOptions = [
    {
      label: 'MT',
      value: 'MT',
    },
    {
      label: 'PT',
      value: 'PT',
    },
  ];

  const handleTimezoneChange = async (value: string) => {
    try {
      await editWorkshopTimezone({
        workshopId,
        timezone: value as TWorkshopTimezone,
      }).unwrap();

      showToastNotification({
        message: t('Timezone has been changed successfully.'),
        type: ENotificationType.SUCCESS,
      });
    } catch (error) {
      showToastNotification({
        message:
          (error as TRtkErrorType)?.data?.message ||
          'Failed to update timezone',
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Flex align="center" data-cy="timezone-selector" gap={8}>
      <Flex align="center" gap={8} style={{ width: 160 }}>
        <TimeOutline size={24} />
        <Text color="#808080">Timezone</Text>
      </Flex>
      <ButtonGroup
        options={timezoneOptions}
        value={timezone ?? undefined}
        size="small"
        disabled={isDisabled}
        onChange={handleTimezoneChange}
        style={{ width: '170px' }}
      />
    </Flex>
  );
};

export default TimezoneSelector;
